import React from 'react';

export interface BrowsePageFrameProps {
  header: React.ReactNode;
  toolbar: React.ReactNode;
  resultSummary: React.ReactNode;
  results: React.ReactNode;
  pagination?: React.ReactNode;
}

const BrowsePageFrame: React.FC<BrowsePageFrameProps> = ({
  header,
  toolbar,
  resultSummary,
  results,
  pagination,
}) => (
  <div className="min-w-0 space-y-6">
    {header}
    <section aria-label="Browse toolbar">
      {toolbar}
    </section>
    <section aria-label="Browse results" className="min-w-0 space-y-3">
      <div className="text-sm text-gray-600 dark:text-gray-300">{resultSummary}</div>
      {results}
    </section>
    {pagination && (
      <section aria-label="Browse pagination">
        {pagination}
      </section>
    )}
  </div>
);

export default BrowsePageFrame;
